import React, {  useState } from 'react';
import AdvanceTableSearchBox from 'components/common/advance-table/AdvanceTableSearchBox';
import IconButton from 'components/common/IconButton';
import {  Col, InputGroup, Row } from 'react-bootstrap';
import PropTypes from 'prop-types';
import AdvanceTableSelectSearchBox from 'components/common/advance-table/AdvanceTableSelectSearchBox';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

const AllTicketsHeader = ({
  globalFilter,
  setGlobalFilter,
  layout,
  handleShow,
  title,
  cursos = [],
  alumnos = [],
}) => {
  const [cursoIdFilter, setCursuIdFilter] = useState('');
      const [ desde , setDesde ] = useState('');
      const [ hasta , setHasta ] = useState('');
 // const [alumnosFiltered, setAlumnosFiltered] = useState(alumnos);
 // const [ alumnosBySeguro , setAlumnosBySeguro ] = useState([]);
 /* 
*/
  /*
  useEffect(() => {
    console.log(alumnosFiltered.length);
    const allSubjects = new Set();
    alumnos.forEach(({ notas = "[]" }) => {
      try {
        const parsedNotas = JSON.parse(notas);
        parsedNotas.forEach(({ subject }) => {
          if (subject) {
            allSubjects.add(subject);
          }
        });
      } catch (error) {
        console.error("Error parsing notas JSON:", error);
      }
    },[]);
  
    // Convertir el conjunto de asignaturas a un array para columnas fijas
    const subjectsArray = Array.from(allSubjects);
  
    const filtered = alumnos
      .filter((alumno) => alumno.curso_id == cursoIdFilter)
      .map(({ 
        firstName, 
        lastName, 
        dni, 
        notas = "[]", 
        promedio_escrito, 
        promedio_oral, 
        promedio 
      }) => {
        let parsedNotas = [];
        try {
          parsedNotas = JSON.parse(notas);
        } catch (error) {
          console.error("Error parsing notas JSON:", error);
        }
  
        // Crear un objeto con todas las columnas de asignaturas inicializadas
        const notasColumns = subjectsArray.reduce((acc, subject) => {
          acc[subject] = null; // Inicializar todas las asignaturas como null
          return acc;
        }, {});
  
        // Completar las columnas de asignaturas con los valores del alumno
        parsedNotas.forEach(({ subject, grade }) => {
          if (subject) {
            notasColumns[subject] = grade || "Sin nota";
          }
        });
  
        // Construir el objeto final con los nombres de columna cambiados
        return {
          Nombre: firstName,
          Apellido: lastName,
          Dni: dni,
          ...notasColumns, // Notas ordenadas por asignatura fija
          Promedio_Escrito: promedio_escrito,
          Promedio_Oral: promedio_oral,
          Promedio: promedio,
        };
      });
    
    setAlumnosFiltered(filtered);
  }, [cursoIdFilter]);
  */  /*
 const formatDateToYYMMDD = (dateString) => {
    if (!dateString) return '';
  
    const date = new Date(dateString);
    const year = date.getFullYear().toString().slice(-2); // Obtiene los últimos 2 dígitos (YY)
    const month = String(date.getMonth() + 1).padStart(2, '0'); // MM (0-padded)
    const day = String(date.getDate()).padStart(2, '0'); // DD (0-padded)
  
    return `${year}/${month}/${day}`;
  };*/
  const toMakeABS = (alumnos) => {
      if (!alumnos) return []; // Manejo seguro si `alumnos` es undefined/null
      return alumnos.map(alumno => ({
        Nombre: alumno.firstName,
        Apellido: alumno.lastName,
        Dni: alumno.dni,
        Direccion: alumno.address,
        Nacimiento: alumno.birthDate,
        Seguro: alumno.seguro,
        FechaInscripcion: alumno.updated_at//formatDateToYYMMDD(alumno.updated_at)
      }));
  };

  let alumnosFiltered = toMakeABS(alumnos).filter(alumno => 
    globalFilter ? Object.values(alumno).some(val => 
       String(val).toLowerCase().includes(String(globalFilter).toLowerCase())
     ):alumno
   );
   if (desde || hasta) {
    alumnosFiltered = alumnosFiltered.filter(alumno => {
      const createdAt = new Date(alumno.FechaInscripcion);
      let passesDesde = true;
      let passesHasta = true;
      
      if (desde) {
        passesDesde = createdAt >= new Date(desde);
      }
      if (hasta) {
        const hastaDate = new Date(hasta);
        hastaDate.setHours(23, 59, 59, 999);
        passesHasta = createdAt <= hastaDate;
      }
      
      return passesDesde && passesHasta;
    });
  }
  const handleExportToExcel = () => {
    if(alumnosFiltered){
    const workbook = XLSX.utils.book_new();
    const worksheet = XLSX.utils.json_to_sheet(alumnosFiltered);

    XLSX.utils.book_append_sheet(workbook, worksheet, 'Alumnos Filtrados');

    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
    saveAs(blob, 'Alumnos_Filtrados.xlsx');
    }
  };
  return (
    <div className="d-lg-flex justify-content-between">
      <Row className="flex-between-center gy-2 px-x1">
        <Col xs="auto" className="pe-0">
          <h6 className="mb-0">{title}</h6>
        </Col>
        <Col xs="auto">
          {layout === 'table-view' ? (
            <AdvanceTableSearchBox
              className="input-search-width"
              globalFilter={globalFilter}
              setGlobalFilter={setGlobalFilter}
              placeholder="Buscar.."
            />
          ) : (
            <InputGroup className="position-relative input-search-width"></InputGroup>
          )}
        </Col>
        <Col xs="auto">
          {cursos.length > 0 && (
            <AdvanceTableSelectSearchBox
              cursos={cursos}
              className="input-search-width"
              globalFilter={globalFilter}
              setGlobalFilter={setGlobalFilter}
              placeholder="Curso"
              cursoIdFilter={cursoIdFilter}
              setCursuIdFilter={setCursuIdFilter}
            />
          )}
        </Col>
      </Row>
            <Row className="flex-between-center gy-2 px-x1">
        <Col>
          <input
            type="date"
            className="form-control input-search-width disable"
            value={desde}
            onChange={(e) => {
              setDesde(e.target.value);
            }}
            placeholder="Desde"
            max={hasta}
          />
        </Col>
        <Col>
          <input
            type="date"
            className="form-control input-search-width"
            value={hasta}
            onChange={(e) =>{
             setHasta(e.target.value);
            } }
            placeholder="Hasta"
            min={desde}
          />
        </Col>
      </Row>
      <div className="d-flex align-items-center justify-content-between justify-content-lg-end px-x1">
        <IconButton
          variant="falcon-default"
          size="sm"
          icon="filter"
          transform="shrink-4"
          iconAlign="middle"
          onClick={handleShow}
          className="d-xl-none"
        >
          <span className="d-none d-sm-inline-block ms-1">Filtro</span>
        </IconButton>
        <IconButton
          variant="falcon-default"
          size="sm"
          icon="external-link-alt"
          transform="shrink-3"
          className="mx-2"
          iconAlign="middle"
          onClick={handleExportToExcel}
        >
          <span className="d-none d-sm-inline-block d-xl-none d-xxl-inline-block ms-1">
            Exportar
          </span>
        </IconButton>
      </div>
    </div>
  );
};

AllTicketsHeader.propTypes = {
  selectedRowIds: PropTypes.object,
  globalFilter: PropTypes.string,
  setGlobalFilter: PropTypes.func,
  handleShow: PropTypes.func,
  layout: PropTypes.string,
  selectedItems: PropTypes.array,
  handleTicketsSearch: PropTypes.func,
  title: PropTypes.string.isRequired,
  cursos: PropTypes.array,
  alumnos: PropTypes.array,
};

export default AllTicketsHeader;
